import {
	SQ_AMBER_PAIR,
	SQ_GREEN_DEEP,
	SQ_GREEN_PAIR,
} from "../../../lib/sq-color-runtime-exports";
export type HexagonPathTileVariant = "default" | "completed" | "active";

export interface HexagonPathTileAppearance {
	gradientTop: string;
	gradientBottom: string;
	strokeColor: string;
	strokeWidthPx: number;
}

export const HEXAGON_PATH_TILE_DEFAULT_OUTER_CORNER_RADIUS_PX = 10;
export const HEXAGON_PATH_TILE_DEFAULT_BORDER_WIDTH_PX = 6;
export const HEXAGON_PATH_TILE_INNER_STROKE_WIDTH_PX = 2;

const PATH_TILE_APPEARANCE: Record<
	HexagonPathTileVariant,
	HexagonPathTileAppearance
> = {
	default: {
		gradientTop: "#FFFFFF",
		gradientBottom: "#DAD3DF",
		strokeColor: "#FFFFFF",
		strokeWidthPx: HEXAGON_PATH_TILE_INNER_STROKE_WIDTH_PX,
	},
	completed: {
		gradientTop: SQ_GREEN_PAIR.from,
		gradientBottom: "#687801",
		strokeColor: SQ_GREEN_DEEP,
		strokeWidthPx: HEXAGON_PATH_TILE_INNER_STROKE_WIDTH_PX,
	},
	active: {
		gradientTop: SQ_AMBER_PAIR.from,
		gradientBottom: SQ_AMBER_PAIR.to,
		strokeColor: "#46311C",
		strokeWidthPx: HEXAGON_PATH_TILE_INNER_STROKE_WIDTH_PX,
	},
};

export function resolveHexagonPathTileVariant(input: {
	isActive: boolean;
	isCompleted: boolean;
}): HexagonPathTileVariant {
	if (input.isActive) {
		return "active";
	}
	if (input.isCompleted) {
		return "completed";
	}
	return "default";
}

export function getHexagonPathTileAppearance(
	variant: HexagonPathTileVariant,
): HexagonPathTileAppearance {
	return PATH_TILE_APPEARANCE[variant];
}

/** Face scale inset linearly from stroke band (matches former SVG stroke inset). */
export function resolveHexagonPathFaceScale(params: {
	innerScale: number;
	hexagonWidth: number;
	hexagonHeight: number;
	strokeWidthPx?: number;
}): number {
	const strokeWidthPx =
		params.strokeWidthPx ?? HEXAGON_PATH_TILE_INNER_STROKE_WIDTH_PX;
	const minDimension = Math.min(
		Math.max(1, params.hexagonWidth),
		Math.max(1, params.hexagonHeight),
	);
	const faceSizePx = minDimension * params.innerScale;
	return Math.max(0, (faceSizePx - 2 * strokeWidthPx) / minDimension);
}
